
import React, { createContext, useContext, useState } from 'react';
import { useToast } from './ToastProvider';
import { Result } from '@peercolab/engine';
import { Session } from '../peer-colab-model/Session';
import { CourseManagment } from '../peer-colab-model/PetKey/BackofficeFE/Client/PathItems';
import { Course } from '../peer-colab-model/PetKey/Main/Model/1_0_Initial/Backoffice/Training/Courses/PathItems';

type CourseContextType = {
  courses: Course[];
  loadCourse: (id: string) => Promise<Result<Course>>
};

const CourseContext = createContext<CourseContextType | undefined>(undefined);

export const CourseProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { onError } = useToast();
  const [courses, setCourses] = useState<Course[]>([]);

  const loadCourse = async (id: string): Promise<Result<Course>> => {
    return onError((await Session.getCourseClient(id).request(CourseManagment.getCourse()))
      .maybePassThroughOk((match) => {
        const updatedCourse = [...courses.filter(c => c.id !== match.id), match];
        setCourses(updatedCourse);
        return match;
      }));
  }

  return (
    <CourseContext.Provider value={{ courses, loadCourse }}>
      {children}
    </CourseContext.Provider>
  );
};

export function useCourses() {
  const ctx = useContext(CourseContext);
  if (!ctx) throw new Error('useCourses must be used within a CourseProvider');
  return ctx;
}
